export default "__VITE_ASSET__CTTYyWGr__"